import React, {useEffect} from "react";
import {
    FormControl, IconButton,
    InputLabel,
    MenuItem,
    Select, SelectChangeEvent,
} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import {TextTrackMode} from "video.js/dist/types/tracks/track-enums";
import {ClearIcon} from "@mui/x-date-pickers-pro";


interface StyledDropdownProps {
    options: any[];
    label: string;
    value: any;
    displayField?: string;
    valueField?: string;
    id: string;
    onChange: (event: SelectChangeEvent) => void;
    paddingTop?: string;
    paddingBottom?: string;
    fullWidth?: boolean;
    minWidth?: string;
    disabled?: boolean;
    borderRadius?: string;
    borderWidth?: string;
    showClearIcon?: boolean;
    handleClear?: (event: React.MouseEvent) => void;
    maxHeight?: string;
    needButtonBackground?: boolean
}


const StyledDropdown: React.FC<StyledDropdownProps> = ({needButtonBackground, id, valueField, options, label, onChange, value, displayField, paddingTop, paddingBottom, fullWidth, minWidth = '200px', disabled = false, borderRadius, borderWidth, showClearIcon, handleClear, maxHeight}) => {

    const theme = useTheme();

    /*useEffect(() => {
        if(options && options.length === 1){
            onChange({target:{value: valueField ? options[0][valueField] : options[0]}} as SelectChangeEvent);
        }
    }, [options])*/

    return (
        <FormControl fullWidth={fullWidth} sx={{minWidth: minWidth, variant: "outlined", paddingTop: paddingTop, paddingBottom: paddingBottom,}}>
            <InputLabel id={id + "-select-label"} sx={{
                color: theme.palette.white,
                paddingTop: paddingTop,
                '&.Mui-focused': {
                    color: theme.palette.white,
                },
                '&.MuiFormLabel-filled': {
                    color: theme.palette.white
                },
                '&.Mui-disabled': {
                    opacity: 0.5,
                    color: theme.palette.lightGrey,
                    '-webkit-text-fill-color': theme.palette.lightGrey,
                },


            }}>{label}</InputLabel>
            <Select
                disabled={disabled}
                id={id + "-select"}
                labelId={id + "-select-label"}
                label={label}
                onChange={(event) => onChange(event)}
                value={value && valueField ? (value[valueField] ? value[valueField] : '')  : (value ? value : '')}
                variant={'outlined'}
                sx={{
                    borderRadius: borderRadius ? borderRadius : null,
                    backgroundColor: needButtonBackground ? theme.palette.blue : 'transparent',
                    color: theme.palette.white,
                    '.MuiSelect-select': {
                        opacity: disabled ? 0.5 : 1,
                        color: disabled ? theme.palette.lightGrey : theme.palette.white,
                        '-webkit-text-fill-color': disabled ? theme.palette.lightGrey : theme.palette.white,
                    },
                    '.MuiSelect-icon': {
                        color: theme.palette.white,
                    },
                    '.MuiOutlinedInput-notchedOutline': {
                        border: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.lightGrey}`
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.white, // Change hover border color here
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.white,
                    },
                    '&.Mui-disabled': {
                        color: theme.palette.lightGrey,
                        '-webkit-text-fill-color': theme.palette.lightGrey,
                        '.MuiOutlinedInput-notchedOutline': {
                            borderColor: theme.palette.lightGrey,
                        },
                        '.MuiSelect-icon': {
                            color: theme.palette.lightGrey,
                        },
                    }


                }}
                MenuProps={{
                    sx: {zIndex: 800001},
                    PaperProps: {
                        sx: {
                            maxHeight: maxHeight ? maxHeight : null,
                            backgroundColor: theme.palette.blue,
                            '& .MuiMenuItem-root': {
                                color: theme.palette.lightGrey,
                                '&.Mui-selected': {
                                    backgroundColor: theme.palette.blue,
                                    color: theme.palette.white,
                                },
                                '&:hover': {
                                    color: theme.palette.white,
                                    backgroundColor: theme.palette.orange,
                                },
                            },
                        },
                    },
                }}
            >
                {options.map( (option, index) => <MenuItem value={valueField ? option[valueField] : option} key={id + '-option-' + index}>{displayField ? option[displayField] : option}</MenuItem>)}
            </Select>
            {showClearIcon && value && value !== "" && (
                <IconButton
                    onClick={handleClear}
                    sx={{
                        position: "absolute",
                        right: 30,
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: theme.palette.white,
                    }}
                    size="small"
                >
                    <ClearIcon fontSize="small" />
                </IconButton>
            )}
        </FormControl>
    );
};

export default StyledDropdown;